import type { ServiceIdentifier } from "inversify";
import { useMemo, use } from "react";
import type IdentityObject from "@/src/domain/common/identity-object";
import { DIContext } from "@/src/infrastructure/di";

export function useInject<T extends IdentityObject>(token: ServiceIdentifier<T>): T {
  const container = use(DIContext);
  if (!container) {
    throw new Error("DIContext must be used within a DIProvider");
  }
  const result = useMemo(() => {
    try {
      return container.container.get<T>(token);
    } catch (e) {
      console.error(`Error injecting ${token.toString()}:`, e);
      throw e;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, container.version]);

  return result;
}

export default useInject;
